
import Vue, { PropType } from 'vue';
import { mergeData } from 'vue-functional-data-merge';

function getWidth(value?: string | number) {
  if (typeof value === 'string') {
    return value;
  }

  if (typeof value === 'number') {
    return `${value}px`;
  }

  return null;
}

const BUMP = ['left', 'right'] as const;

export default Vue.extend({
  functional: true,
  inject: {
    of: { default: '12' },
  },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    size: {
      type: [String, Number],
      default: undefined,
    },
    width: {
      type: [String, Number],
      default: undefined,
    },
    grow: {
      type: Boolean,
      default: undefined,
    },
    shrink: {
      type: Boolean,
      default: false,
    },
    bump: {
      type: String as PropType<typeof BUMP[number]>,
      default: undefined,
      validator: (val) => BUMP.includes(val),
    },
  },
  render(h, { props, data, children, injections }) {
    const { tag, size, width, grow, shrink, bump } = props;

    return h(
      tag,
      mergeData(data, {
        staticClass: 'bc-col',
        class: {
          'slds-col': shrink === false,
          [`slds-size_${size}-of-${injections.of}`]: size,
          'slds-grow': grow === true,
          'slds-shrink-none': width || shrink !== false,
          'slds-grow-none': width || grow === false,
          [`slds-col_bump-${bump}`]: bump,
        },
        style: {
          width: getWidth(width),
        },
      }),
      children
    );
  },
});
